<mat-sidenav-container class="layout-shell">
  <!-- ═══ SIDEBAR ═══ -->
  <mat-sidenav
    #sidenav
    [mode]="isDesktop() ? 'side' : 'over'"
    [opened]="isDesktop()"
    class="layout-sidebar"
    data-testid="sidebar"
  >
    <!-- Logo -->
    <a routerLink="/" class="layout-logo" aria-label="Brijjworks home" data-testid="app-logo">
      <img [src]="portalTheme.logoPath()" alt="" class="layout-logo-img" aria-hidden="true" />
      <div class="layout-logo-text">
        <div class="layout-logo-brand">{{ portalTheme.portalLabel() }}</div>
      </div>
    </a>

    <!-- Navigation -->
    <mat-nav-list class="layout-nav">
      @for (sec of sections(); track sec.title) {
        <div class="layout-section">
          @if (sec.title) {
            <div class="layout-section-title">{{ sec.title }}</div>
          }
          @for (item of sec.items; track item.route) {
            @if (isNavItemVisible(item)) {
              <a
                mat-list-item
                class="layout-nav-item"
                [routerLink]="item.route"
                routerLinkActive="active"
                [attr.data-testid]="'sidebar-nav-' + item.route.replace('/', '')"
              >
                <app-icon
                  [name]="item.icon"
                  [size]="16"
                  matListItemIcon
                  class="layout-nav-icon"
                  aria-hidden="true"
                ></app-icon>
                <span matListItemTitle class="layout-nav-label">{{ item.label }}</span>
                @if (item.badge) {
                  <span class="layout-nav-badge">{{ item.badge }}</span>
                }
              </a>
            }
          }
        </div>
      }
    </mat-nav-list>
  </mat-sidenav>

  <!-- ═══ MAIN ═══ -->
  <mat-sidenav-content class="layout-main">
    <!-- Toolbar -->
    <mat-toolbar class="layout-toolbar">
      @if (!isDesktop()) {
        <button mat-icon-button (click)="sidenav.toggle()" aria-label="Toggle navigation menu">
          <app-icon name="menu" [size]="20" aria-hidden="true"></app-icon>
        </button>
      }

      <span class="layout-toolbar-title" data-testid="shell-page-title">{{ activeCrumb() }}</span>
      <span class="spacer"></span>

      <!-- Active store picker — consignment-accepting stores only -->
      @if (storeCtx.stores().length && userRolePermission.hasPermission('StoreContext:Switch')) {
        <mat-form-field
          appearance="outline"
          subscriptSizing="dynamic"
          class="layout-store-select"
          data-testid="store-picker"
        >
          <mat-select [formControl]="storeControl" panelClass="layout-store-panel" aria-label="Active store">
            @for (store of storeCtx.stores(); track store.id) {
              <mat-option [value]="store.id">{{ store.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }

      <app-switcher [apps]="appSwitcher.apps()" />

      <!-- Navbar profile -->
      <div
        class="layout-profile-wrap"
        (click)="$event.stopPropagation()"
        (keydown)="$event.stopPropagation()"
        role="presentation"
      >
        <button
          #profileBtn
          type="button"
          class="layout-profile-btn"
          (click)="profileOpen.set(!profileOpen())"
          [attr.aria-expanded]="profileOpen()"
          aria-haspopup="menu"
          aria-label="User profile menu"
          data-testid="profile-cluster"
        >
          <div class="layout-avatar">
            @if (currentUser.profileFileUrl(); as photoUrl) {
              <img [src]="photoUrl" alt="" />
            } @else {
              {{ currentUser.initials() }}
            }
          </div>
          <div class="layout-user-info">
            <span class="layout-user-name">{{ currentUser.displayName() }}</span>
            @if (ddRoles().length) {
              <span class="layout-user-roles">
                <span class="layout-user-role-chip">{{ ddRoles()[0] }}</span>
                @if (ddRoles().length > 1) {
                  <span class="layout-user-role-more" [title]="ddRoles().slice(1).join('\n')">
                    +{{ ddRoles().length - 1 }}
                  </span>
                }
              </span>
            } @else {
              <span class="layout-user-role">{{ profileSubtitle() }}</span>
            }
          </div>
          <app-icon
            name="chevron-down"
            [size]="12"
            class="layout-profile-chevron"
            [class.rotated]="profileOpen()"
            aria-hidden="true"
          ></app-icon>
        </button>
      </div>
    </mat-toolbar>

    <!-- Content -->
    <main id="main-content" tabindex="-1" class="layout-content">
      <ng-content />
    </main>

    <!-- Mobile bottom navigation — hidden ≥1024px via component CSS -->
    <app-bottom-nav [tabs]="bottomNavTabs" (tabAction)="onBottomNavAction($event)" />
  </mat-sidenav-content>
</mat-sidenav-container>

<!-- Outside mat-sidenav-container: escapes its stacking context so z-index beats sticky table headers -->
@if (profileOpen()) {
  <div
    class="profile-panel"
    role="menu"
    aria-label="User profile menu"
    tabindex="-1"
    (click)="$event.stopPropagation()"
    (keydown)="$event.stopPropagation()"
  >
    <div class="pdd-hero">
      <div class="pdd-hero-avatar">
        @if (currentUser.profileFileUrl(); as photoUrl) {
          <img [src]="photoUrl" alt="" />
        } @else {
          {{ currentUser.initials() }}
        }
      </div>
      <div class="pdd-hero-name">{{ currentUser.displayName() }}</div>
      <div class="pdd-hero-email">{{ currentUser.email() }}</div>
    </div>
    <mat-divider></mat-divider>
    <button type="button" role="menuitem" class="profile-menu-item danger" (click)="signOut()">Sign Out</button>
  </div>
}

<!-- Global command palette — Cmd/Ctrl+K to open -->
<app-command-palette />

<!-- Signal-backed toast stack — replaces MatSnackBar -->
<app-toast-host />
